import { Dialog, DialogContent, DialogTitle } from "@mui/material";

import ShareReportContent from "./ShareReportContent";

interface ShareReportDialogProps {
  isShareDialogOpen: boolean;
  setIsShareDialogOpen: (value: boolean) => void;
  appName: string;
  orgId: string;
  id: string;
}

const ShareReportDialog = ({
  isShareDialogOpen,
  setIsShareDialogOpen,
  appName,
  orgId,
  id,
}: ShareReportDialogProps) => {
  const appTitle = appName === "rubiregistry" ? "Registry" : "Report";

  return (
    <Dialog
      open={isShareDialogOpen}
      onClose={() => {
        setIsShareDialogOpen(false);
      }}
    >
      <DialogTitle>Share {appTitle}</DialogTitle>
      <DialogContent>
        <ShareReportContent
          appName={appName}
          orgId={orgId}
          submissionId={id}
          appTitle={appTitle}
          framed={false}
          onShared={() => setIsShareDialogOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ShareReportDialog;
